import React, {
	//useState,
	//useEffect,
	//useCallback,
} from 'react';

//import {
	//toDate,
	//zonedTimeToUtc,
	//utcToZonedTime,
	//format
//} from 'date-fns-tz';

import { CheckAuth } from 'pages/auth/actions.js';
import Card from 'react-bootstrap/Card';
import Container from 'react-bootstrap/Container';
import OPWBreadcrumb from 'components/breadcrumb.js';
import Header from 'components/header.js';
import Footer from 'components/footer.js';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
//import Modal from 'react-bootstrap/Modal';
import Form from 'react-bootstrap/Form';
import ButtonGroup from 'react-bootstrap/ButtonGroup';
import Button from 'react-bootstrap/Button';
//import { Link } from "react-router-dom";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { AnimalAgeSelect } from 'components/animalAgeSelect.js';
import { TimezoneSelect } from 'components/timezoneSelect.js';
import { AnimalSizeSelect } from 'components/animalSizeSelect.js';
import { AnimalGenderSelect } from 'components/animalGenderSelect.js';
import { BreedTypeSelect } from 'components/breedTypeSelect.js';
import GenericModal from 'components/genericModal.js';
import {
	SessionName,
	SessionEndDate,
	HeadCount,
	PaddockSize,
} from './controls.js'

//const TITLE = 'Session Management'
const BC = OPWBreadcrumb;

export const SessionDetail = (props) =>{
	//console.dir(props)
	return (
		<>
			<CheckAuth groupName = { 'admin' } />
			<Header><BC trail={'[["Home", "/"], ["Session management", "/manage/session"], ["' + (props.values.SessionName || 'New session') + '", ""]]'} /></Header>
			<Container fluid className="body">
				<Form onSubmit={ props.handleSubmit } >
					<SessionDetailControls { ...props } />
					<br />
				</Form>
			</Container>
			<Container fluid>
				<Row>
					<Col sm='12'>
						<Footer />
					</Col>
				</Row>
			</Container>
		</>
	)
}

const Controls = (props) =>{
	const {
		setSessionDetailShow,
		modified,
		valMsg,
		addingNewSession,
		setAddingNewSession,
	} = props

	const msg = (valMsg)?`Warning: ${valMsg}. Fix and try again.`:'';
	//const disableControl = (addingNewSession || weigherId === null || weigherId === undefined)
	const title = (modified)?'click to save changes':'locked - no data modified';

	const handleExit = () =>{
		if (addingNewSession){
			setAddingNewSession(false);
		}
		setSessionDetailShow(false);
	}

	return (
		<div className="formButtons">
			<p className={"validationError" + (msg === "" ? " hidden" : "")}>{ msg }</p>
			<ButtonGroup>
				{/* <Button
					variant="info"
					onClick={() => setSessionChangeModalShow(true)}
					{ ...(disableControl && { disabled: true }) }
				>{ modalBtnDesc }</Button> */}
				<Button
					type='submit'
					variant="outline-primary"
					title = { title }
					{ ...(!modified && { disabled: true }) }
					{ ...(!modified && { variant: "outline-secondary" }) }
				>
					Save changes
				</Button>
				<Button
					variant="outline-primary"
					onClick={() => handleExit()}
				>
					Exit without saving
				</Button>
				{/* <Link to = "/"><Button variant="info" { ...(!modified && { disabled: true }) }>Exit without saving</Button></Link> */}
			</ButtonGroup>
		</div>
	)
}

/**
 * This is all the detail form controls for setting data in a session
 * @param {} props
 */
export const SessionDetailControls = (props) => {
	const {
		cols,
		controlStyle,
		handleChange,
		values,
		defaultTimezone,
		addingNewSession,
		modalExitWithoutSavingShow,
		setModalExitWithoutSavingShow,
		modalExitWithoutSavingData,
		handleModalExitWithoutSaving,
		handleSessionStartObjChange,
		handleSessionEndObjChange,
		//weigherId,
	} = props;
	//const lock = !(addingNewSession || values.isOpen)
	const lock = false;	//changed so any status of session can be editied

	// const status = () =>{
	// 	if (addingNewSession){
	// 			return 'Adding NEW session';
	// 	// } else if (values.isOpen){
	// 	// 		return 'Editing OPEN session'
	// 	} else {
	// 			return values.SessionName;
	// 	}
	// }
	//console.log('weigherId', weigherId)
	//console.log('debug values.sessionEndObj',values.sessionEndObj)
	// const endDatef = (values.sessionEndObj === null || values.sessionEndObj === undefined)? 'n/a - still open': format(values.sessionEndObj, 'dd MMM yyyy HH:mm:ss', {});
	//console.log('lock', lock)
	return (
		<>
				<Row>
					<Col>
						<Card body>
							<Card.Title>{ values.SessionName || 'New session' }</Card.Title>
							<Card.Body>
								<SessionName
									cols = { cols }
									controlStyle = { controlStyle }
									required = {true}
									handleChange = {(evt) => handleChange(evt)}
									value = { values.SessionName || '' }
									lock = { lock }
									//value = { values || '' }
								/>
								<TimezoneSelect
									cols = { cols }
									controlStyle = { controlStyle }
									required = {true}
									handleChange = {(evt) => handleChange(evt)}
									value = { values.timezone || defaultTimezone }
									lock = { lock }
								/>

								<Row className="inputRow">
									<Col sm={ cols.lhs }>Session start:</Col>
									<Col sm={ cols.rhs }>
										<DatePicker
											//id = 'sessionStartObj'
											className = { 'datepickerxx form-control' }
											//className = { 'datepicker' }
											dateFormat = { "dd MMM yyyy HH:mm" }
											selected={ values.sessionStartObj || new Date() }
											showTimeSelect
											todayButton = { "Now" }
											timeIntervals = { 15 }
											scrollableYearDropdown = { true }
											showYearDropdown = { true }
											onChange={ (dateObj) => handleSessionStartObjChange(dateObj) }
											style = { controlStyle }
											{ ...(lock && { disabled: true }) }
											//{ ...{ disabled: true } }
										/>
									</Col>
								</Row>
								{
									!addingNewSession &&
									<SessionEndDate
									cols = { cols }
									value = { values.sessionEndObj }
									handleSessionEndObjChange = { handleSessionEndObjChange }
									//controlStyle = {{...{width: '15em'},...controlStyle}}
									controlStyle = {controlStyle }
									lock = { lock }
								/>
								}

								<HeadCount
									cols = { cols }
									controlStyle = { controlStyle }
									required = {true}
									handleChange = {(evt) => handleChange(evt)}
									value = { values.Head || '' }
									lock = { lock }
								/>
								<BreedTypeSelect
									cols = { cols }
									controlStyle = {{...{width: '15em'},...controlStyle}}
									required = {true}
									handleChange = {(evt) => handleChange(evt)}
									value = { values.BreedType || '' }
									lock = { lock }
								/>
								<AnimalGenderSelect
									cols = { cols }
									controlStyle = {{...{width: '15em'},...controlStyle}}
									required = {true}
									handleChange = {(evt) => handleChange(evt)}
									value = { values.Sex || '' }
									lock = { lock }
								/>
								<AnimalAgeSelect
									cols = { cols }
									controlStyle = {{...{width: '15em'},...controlStyle}}
									required = {true}
									handleChange = {(evt) => handleChange(evt)}
									value = { values.Age || '' }
									lock = { lock }
								/>
								<AnimalSizeSelect
									cols = { cols }
									controlStyle = {{...{width: '15em'},...controlStyle}}
									required = { true }
									handleChange = {(evt) => handleChange(evt)}
									value = { values.Size || '' }
									lock = { lock }
								/>
								<PaddockSize
									cols = { cols }
									controlStyle = { controlStyle }
									required = { true }
									handleChange = {(evt) => handleChange(evt)}
									value = { values.Paddock || '' }
									readOnly = { true }
									lock = { lock }
								/>
								<GenericModal
									title = 'Exit without saving?'
									bodyTxt = 'You are changing sessions with changes without saving!'
									show = { modalExitWithoutSavingShow }
									setShow = { setModalExitWithoutSavingShow }
									buttons = {[{desc:'Exit without saving changes', id:'loseChangesBtn'}, {desc:'Cancel', id:'cancelExitBtn'}]}
									data = { modalExitWithoutSavingData || {} }
									handleButton = { (data) => handleModalExitWithoutSaving(data) }
								/>

								<Controls { ...props } />

							</Card.Body>
						</Card>
					</Col>
				</Row>
		</>
	)
}